import { z } from 'zod';
import { COMMISSIONING_VP_EVENT_FAMILIES } from '../types/commissioning';

const uuid = z.string().uuid();

/**
 * Pacchetti valenze (VP) della gara: la gara ne abbina uno o più (testa viva
 * della catena versioni, famiglia evento compatibile con la famiglia gara);
 * ogni configuratore ne sceglie UNO fra questi e lo trasmette a tutti i suoi
 * cluster e celle driver.
 */
export const commissioningCompetitionValuePackageDtoSchema = z.object({
  value_package_id: uuid,
  name: z.string(),
  event_family: z.enum(COMMISSIONING_VP_EVENT_FAMILIES),
  version_group_id: uuid,
  version: z.number().int().positive(),
  is_active: z.boolean(),
  published_at: z.string().nullable(),
  archived_at: z.string().nullable(),
  /** Configuratori della gara che lavorano su questo VP: se > 0 la rimozione è bloccata. */
  used_by_instances: z.array(z.object({ id: uuid, name: z.string() }).strict()),
}).strict();
export type CommissioningCompetitionValuePackageDto = z.infer<typeof commissioningCompetitionValuePackageDtoSchema>;

export const commissioningCompetitionValuePackagesListSchema = z.object({
  items: z.array(commissioningCompetitionValuePackageDtoSchema),
}).strict();
export type CommissioningCompetitionValuePackagesList = z.infer<typeof commissioningCompetitionValuePackagesListSchema>;

/** Sostituzione integrale dell'insieme di VP della gara (idempotente). */
export const replaceCommissioningCompetitionValuePackagesSchema = z.object({
  value_package_ids: z.array(uuid).max(100),
}).strict().superRefine((value, ctx) => {
  if (new Set(value.value_package_ids).size !== value.value_package_ids.length) {
    ctx.addIssue({ code: z.ZodIssueCode.custom, path: ['value_package_ids'], message: 'Pacchetto valenze duplicato' });
  }
});
export type ReplaceCommissioningCompetitionValuePackagesInput = z.infer<typeof replaceCommissioningCompetitionValuePackagesSchema>;
